import React from "react";

export default function FormField({ field, value, error, onChange, formData }) {
  const inputClass = error
    ? "w-full p-2 border border-red-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    : "w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500";

  const showError = error && (
    <span className="text-red-500 text-sm">{error}</span>
  );

  const helperMessageFields = [
    "main_date_of_birth",
    "main_gender",
    "patient_date_of_birth",
    "patient_gender",
    "patient_age",
  ];

  const isMainOrPatientID =
    field.name === "main_identification_number" ||
    field.name === "patient_identification_number";

  const label = (
    <div className="flex justify-between items-center mb-1">
      <label className="block text-sm font-medium text-gray-700">
        {field.label}
      </label>
      {isMainOrPatientID && (
        <label className="text-sm text-gray-600 flex items-center">
          <input
            type="checkbox"
            name={
              field.name === "main_identification_number"
                ? "non_sa_main_id"
                : "non_sa_patient_id"
            }
            checked={
              field.name === "main_identification_number"
                ? formData.non_sa_main_id
                : formData.non_sa_patient_id
            }
            onChange={onChange}
            className="mr-1"
          />
          Non SA id?
        </label>
      )}
    </div>
  );

  const renderField = () => {
    switch (field.type) {
      case "radio":
        return (
          <div className="flex flex-col">
            <div className="flex space-x-6">
              {field.options.map((option) => (
                <div key={option}>
                  <input
                    type="radio"
                    id={`${field.name}_${option}`}
                    name={field.name}
                    value={option}
                    checked={value === option}
                    onChange={onChange}
                    className="mr-2"
                    disabled={field.disabled === true}
                  />
                  <label
                    htmlFor={`${field.name}_${option}`}
                    className="text-sm font-medium text-gray-700"
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>
            {helperMessageFields.includes(field.name) && (
              <span className="text-xs text-gray-500 mt-1">
                Ensure ID Number is completed and correct
              </span>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div className="flex items-center">
            <input
              type="checkbox"
              name={field.name}
              checked={value}
              onChange={onChange}
              className="w-5 h-5 mr-2"
            />
            <label className="text-sm font-medium text-gray-700">
              {field.description}
            </label>
          </div>
        );

      case "select-text":
        return (
          <input
            list={`${field.name}-options`}
            name={field.name}
            value={value}
            onChange={onChange}
            className={inputClass}
            disabled={field.disabled === true}
          />
        );

      case "phone":
        return (
          <input
            type="text"
            name={field.name}
            maxLength="10"
            value={value}
            onChange={(e) => {
              const val = e.target.value;
              if (/^0\d{0,9}$/.test(val) || val === "") {
                onChange(e);
              }
            }}
            className={inputClass}
            disabled={field.disabled === true}
          />
        );

      case "email":
        return (
          <input
            type="email"
            name={field.name}
            value={value}
            onChange={onChange}
            className={inputClass}
            disabled={field.disabled === true}
          />
        );

      case "height":
        return (
          <div className="flex gap-2">
            <input
              type="number"
              placeholder="m"
              className={inputClass}
              value={formData[field.name]?.split(",")[0] || ""}
              onChange={(e) => {
                const cm = formData[field.name]?.split(",")[1] || "0";
                onChange({
                  target: {
                    name: field.name,
                    value: `${e.target.value},${cm}`,
                  },
                });
              }}
            />
            <input
              type="number"
              placeholder="cm"
              className={inputClass}
              value={formData[field.name]?.split(",")[1] || ""}
              onChange={(e) => {
                const m = formData[field.name]?.split(",")[0] || "0";
                onChange({
                  target: {
                    name: field.name,
                    value: `${m},${e.target.value}`,
                  },
                });
              }}
            />
          </div>
        );

      case "weight":
        return (
          <div className="flex items-center space-x-2">
            <input
              type="number"
              name={field.name}
              value={value}
              onChange={onChange}
              className="w-20 p-2 border border-gray-300 rounded-lg"
              disabled={field.disabled === true}
            />
            <span>kg</span>
          </div>
        );

      default:
        const isIDField =
          field.name === "main_identification_number" ||
          field.name === "patient_identification_number";
        return (
          <>
            <input
              type={
                (field.name === "patient_date_of_birth" ||
                  field.name === "main_date_of_birth") &&
                ((field.name === "patient_date_of_birth" &&
                  formData.non_sa_patient_id) ||
                  (field.name === "main_date_of_birth" &&
                    formData.non_sa_main_id))
                  ? "date"
                  : "text"
              }
              name={field.name}
              value={value}
              onChange={(e) => {
                const val = isIDField
                  ? e.target.value.replace(/\s/g, "")
                  : e.target.value;
                onChange({ target: { name: field.name, value: val } });
              }}
              className={inputClass}
              disabled={field.disabled === true}
            />

            {helperMessageFields.includes(field.name) && (
              <span className="text-xs text-gray-500 mt-1 block">
                Ensure ID Number is completed and correct
              </span>
            )}
          </>
        );
    }
  };

  return (
    <div className="mb-4">
      {label}
      {renderField()}
      {field.type === "select-text" && (
        <datalist id={`${field.name}-options`}>
          {field.options?.map((opt) => (
            <option key={opt} value={opt} />
          ))}
        </datalist>
      )}
      {showError}
    </div>
  );
}
